<template>
  <div>
    <el-tree
      ref="orgTree"
      :data="orgs"
      node-key="id"
      :props="defaultProps"
      default-expand-all
      :expand-on-click-node="false"
      @node-click="handleNodeClick"
    ></el-tree>
  </div>
</template>

<script>
import { listOrgTree } from "@/api/work/repairTypeUserApi";

export default {
  name: "OrgTreeShow",
  // 定义 props 接收 communityId
  props: {
    communityId: {
      type: String,
      default: "", // 默认为空字符串
    },
  },
  data() {
    return {
      orgs: [],
      defaultProps: {
        children: "children",
        label: "text",
      },
    };
  },
  methods: {
    async refreshTree() {
      try {
        let communityId = this.communityId; // 优先使用父组件传入的 communityId

        const params = {
          communityId: communityId,
        };
        const response = await listOrgTree(params);
        if (response.code === 0) {
          this.orgs = [response.data];
        } else {
          this.$message.error(
            response.msg || this.$t("暂时无法查询非当前账号园区"),
          );
        }
      } catch (error) {
        console.error("Error loading org tree:", error);
        this.$message.error(this.$t("暂时无法查询非当前账号园区"));
      }
    },
    handleNodeClick(data) {
      this.$emit("org-selected", {
        orgId: data.id,
        orgName: data.text,
      });
    },
  },
  mounted() {
    // 注意：这里不再自动调用 refreshTree，因为现在由父组件控制何时刷新
    // this.refreshTree();
  },
};
</script>
